var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('IconBase',{attrs:{"color":_vm.color,"size":_vm.size}},[_c('CloseSvg')],1)}
var staticRenderFns = []

export { render, staticRenderFns }